import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {generate} from '../../../routes.js'
import actions from '../../CurrentUserLoader/actions.js'
import api from '../../../../api.js'
import {handleResponseErrors} from '../../../services/processServerErrors.js'
import conf from '../../../../shared/conf.js'

import Modal from '../../../../shared/components//Modals/Modal.jsx'
import UserForm from '../../Forms/UserForm/UserForm.jsx'
import SubmitButton from '../../Forms/UserForm/SubmitButton.jsx'

class UserAddModal extends Modal {
  constructor(props) {
    super(props)
    this.state = {
      errors: null,
    }
    this.close = () => this.props.closeModal()
  }

  submit = async (values) => {
    return api.users.add(values).catch(handleResponseErrors)
  }

  onFormSuccess = (val) => {
    const data = val.data
    if (data && data.freelance_id) {
      window.location = generate({
        name: 'old-freelance-profile',
        parameters: {
          slug: 'freelance',
          freelance_id: data.freelance_id,
          user_id: data.id,
        }
      })
    }
    this.close()
  }

  render() {
    return (
      <BootstrapModal toggle={this.close} isOpen={this.props.isOpen} className="user-modal" size="lg" backdrop="static">
        <ModalHeader toggle={this.close}>Ajouter un utilisateur</ModalHeader>
        <ModalBody>
          <UserForm
            onSubmit={this.submit}
            onSubmitSuccess={this.onFormSuccess}
            initialValues={{
              account_type: conf.accountTypes.freelance,
              main_universe: this.props.currentUniverseId
            }}
            error={this.state.errors}
          />
          <div className="text-center">
            <SubmitButton className="mx-auto btn btn-primary">Sauvegarder</SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state?.universe?.currentUniverse?.id ?? null
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(UserAddModal)